import React, {  useState } from "react";
import NavBar from "../Components/NavBar";
import Textarea from "../Components/Form/Textarea";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updateWorkoutData } from "../Features/workoutSlice";


export default function Workout() {
  const dispatch = useDispatch();
  const workout = useSelector((state) => state.workout);
  // console.log(workout)
  const [isEdit, setIsEdit] = useState(false);
  const { register, handleSubmit } = useForm({
    defaultValues: {
      monday : workout.workoutPlane.monday,
      tuesday : workout.workoutPlane.tuesday,
      wednesday : workout.workoutPlane.wednesday,
      thursday : workout.workoutPlane.thursday,
      friday : workout.workoutPlane.friday,
      saturday : workout.workoutPlane.saturday,
  }
  });


  // const workout = useSelector((state) => state.workout.workout)


  const saveWorkout = (data) => {
    // console.log(data)
    dispatch(updateWorkoutData({workoutId : workout.workoutId,workout : data}))
    setIsEdit(false)
  };

  return (
    <>
      <NavBar />
      <h2 className="text-center text-3xl m-10">Workouts</h2>
      <form className="sm:max-w-lg max-w-sm mx-auto mb-20" onSubmit={handleSubmit(saveWorkout)}>
        <Textarea
          label="Monday"
          placeholder="Monday Workouts"
          rows="3"
          disabled={!isEdit}
          {...register("monday", {required : true})}
        />
        <Textarea
          label="Tuesday"
          placeholder="Tuesday Workouts"
          rows="3"
          disabled={!isEdit}
          {...register("tuesday", {required : true})}
        />
        <Textarea
          label="Wednesday"
          placeholder="Wednesday Workouts"
          rows="3"
          disabled={!isEdit}
          {...register("wednesday", {required : true})}
        />
        <Textarea
          label="Thursday"
          placeholder="Thursday Workouts"
          rows="3"
          disabled={!isEdit}
          {...register("thursday", {required : true})}
        />
        <Textarea
          label="Friday"
          placeholder="Friday Workouts"
          rows="3"
          disabled={!isEdit}
          {...register('friday', {required : true})}
        />
        <Textarea
          label="Saturday"
          placeholder="Saturday Workouts"
          rows="3"
          disabled={!isEdit}
          {...register("saturday", {required : true})}
        />

        <div className="flex m-3 justify-center">
          {isEdit ? (
            <>
              <button
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                {" "}
                Save{" "}
              </button>
              <button
              type="submit"
                onClick={ (e) => {
                  e.preventDefault();
                  setIsEdit(false);
                }}
                className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
              >
                Cancel
              </button>
            </>
          ) : (
            <button
              onClick={(e) => {
                e.preventDefault();
                setIsEdit(true);
              }}
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            >
              {" "}
              Edit{" "}
            </button>
          )}
        </div>
      </form>
    </>
  );
}
